import { Button, Divider, Paper } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Column from "../../../../atoms/Column";
import Columns from "../../../../atoms/Columns";
import Loading from "../../../../atoms/Loading";
import { Props } from "../../../../pages/Crew/Bunkering/Create/types";
import Detail from "../../../../organisms/Crew/Bunkering/Detail";
import SucsessButton from "../../../../atoms/SucsessButton";
import ErrorMessageList from "../../../../atoms/ErrorMessageList";
import { ErrorMessageData } from "../../../../../hooks/errorMessage.hook";

type ConfirmProps = Props & {
  isLoading: boolean;
  onUpdate(): Promise<void>;
  onBack(): void;
  reportId: number;
  setIsDetail: React.Dispatch<React.SetStateAction<boolean>>;
  errorMessageList: ErrorMessageData[];
};

const ServerUpdateBunkeringConfirm = (
  props: ConfirmProps
): React.ReactElement => {
  const onClickCreate = () => {
    props.onUpdate();
  };

  return (
    <React.Fragment>
      <Loading isLoading={props.isLoading} />

      <Paper sx={{ backgroundColor: "#27292E", borderRadius: "20px" }}>
        <Detail
          isPreview={false}
          form={props.form}
          pageTitle={"Update Bunkering Report"}
          isSend={false}
          isServer={true}
        />
        <Divider textAlign="left"></Divider>
        <ErrorMessageList errorMessageList={props.errorMessageList} />
        <Box sx={{ p: 2 }}>
          <Columns>
            <Column>
              <SucsessButton
                ButtonName={"Save"}
                disabled={false}
                onClick={onClickCreate}
              />
            </Column>

            <Column>
              <Button
                sx={{
                  mx: 2,
                  color: "#AAAAAA",
                  width: 150,
                  backgroundColor: "#555860",
                  textTransform: "none",
                }}
                variant="contained"
                disabled={false}
                onClick={() => props.onBack()}
              >
                {`Back & Edit`}
              </Button>
            </Column>
            <Column>
              <Button
                sx={{
                  mx: 2,
                  width: 150,
                  color: "#AAAAAA",
                  backgroundColor: "#555860 ",
                  textTransform: "none",
                }}
                variant="contained"
                disabled={false}
                onClick={() => props.onBack()}
              >
                Cancel
              </Button>
            </Column>
          </Columns>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default ServerUpdateBunkeringConfirm;
